import { SolViewId, SolViewOptions } from '@sol/components';
import { AsmAttachmentViewOptions } from '../components/view/asm-view-read-attachments/asm-attachment-view-options';
import { AsmOwaspTopTenViewOptions } from '../components/view/asm-view-read-owasp-top-ten/asm-owasp-top-ten-view-options';

export class AsmCollaborationViewId {
  public static readonly attachmentCompact = SolViewId.of<SolViewOptions>('asm.attachmentCompact');
  public static readonly attachments = SolViewId.of<AsmAttachmentViewOptions>('asm.attachments', {
    interactive: true,
  });
  public static readonly owaspTopTen = SolViewId.of<AsmOwaspTopTenViewOptions>('asm.owaspTopTen');
  public static readonly owaspVersionEdit = SolViewId.of<SolViewOptions>('asm.owaspVersionEdit');
}
